function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

document.addEventListener("DOMContentLoaded", code);
import Swiper, { Pagination } from 'swiper';
import 'swiper/css';
import 'swiper/css/pagination';

function defaultSwiperSettings() {
  var slidesPerView = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
  var speed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
  var autoplay = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var autoHeight = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  return {
    modules: [Pagination],
    autoplay: autoplay,
    speed: speed,
    slidesPerView: slidesPerView,
    centerInsufficientSlides: true,
    autoHeight: autoHeight,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    a11y: true
  };
}

if (window.acf) {
  window.acf.addAction('render_block_preview/type=feedback-block', code);
}

function code(event) {
  if (document.querySelectorAll('.feedback-block')) {
    var sliders = document.querySelectorAll('.feedback-block');
    sliders.forEach(function (slider) {
      var text_swiper = new Swiper(slider.querySelector('.testimonial-text-swiper'), _objectSpread(_objectSpread({}, defaultSwiperSettings('auto', 330, false, false)), {}, {
        loop: false,
        pagination: {
          el: "#" + slider.id + " .swiper-pagination",
          type: "bullets",
          clickable: true
        }
      }));
    });
  }
}